export default __webpack_public_path__ + "static/lb-2-a9e0a151010cfdfe9ac5163fe4910ab7.jpg";